import { useRouter } from 'next/router'
import { FC, useEffect, useState } from 'react'

import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  PinterestShareButton,
  PinterestIcon,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share'

const Share: FC<{ image: string }> = ({ image }) => {
  const router = useRouter()
  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const fullUrl = window.location.href // Get the complete URL with protocol, hostname, etc.
      setCurrentUrl(fullUrl)
    }
  }, [router])

  return (
    <div className="relative   right-11 bottom-12 xsp:bottom-12  sm:bottom-10">
      <div className=" flex flex-col space-y-1 items-center">
        <FacebookShareButton
          url={currentUrl}
          //  qoute={name}
          qoute="Babys Only Organic Plant Based Pea Protein Toddler Formula, 12.7 Ounce -- 6 per case"
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton
          url={currentUrl}
          //   title={name}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <PinterestShareButton url={currentUrl} media={image}>
          <PinterestIcon size={32} round />
        </PinterestShareButton>
        <EmailShareButton url={currentUrl}>
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  )
}

export default Share
